import { useMemo } from "react";
//#region src/index.ts
var useReviewsRoutableTypes = () => {
	return useMemo(() => ({}), []);
};
//#endregion
export { useReviewsRoutableTypes };
